import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getMonsters, getTraits } from "../logic/Logic.js";
import * as actions from "../redux/actions/actions.js";
import MonsterTable from "./MonsterTable.js";

const Play = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    listMonsters();
  }, []);

  const listMonsters = async () => {
    const ret = { monsters: getMonsters(), traits: getTraits() };
    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>

      {infos?.monsters && MonsterTable({ monsters: infos?.monsters })}
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
  story: state.Reducer.story,
});

const mapDispatchToProps = (dispatch) => ({
  setStory: (story) => dispatch(actions.setStory(story)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
